import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgAppleLogoSmall = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__apple-logo-small_svg__a)">
        <path
          d="M10.71 4.1c.94-1.236 2.244-1.242 2.244-1.242s.194 1.163-.738 2.283c-.996 1.196-2.127 1-2.127 1s-.213-.94.622-2.04Zm-.502 2.856c.483 0 1.379-.663 2.545-.663 2.008 0 2.798 1.428 2.798 1.428s-1.545.79-1.545 2.707c0 2.162 1.925 2.907 1.925 2.907s-1.345 3.787-3.163 3.787c-.834 0-1.483-.563-2.363-.563-.896 0-1.785.584-2.364.584-1.66 0-3.756-3.592-3.756-6.48 0-2.84 1.775-4.33 3.439-4.33 1.082 0 1.921.623 2.484.623Z"
          fill="#999"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__apple-logo-small_svg__a">
          <path
            fill="#fff"
            transform="translate(4.285 2.857)"
            d="M0 0h11.646v14.286H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgAppleLogoSmall;
